
export function isInAppWebView(device) {
  if (!isMobile(device)) {
    return false;
  }
  const deviceUa = device.get('ua');
  const regexp = new RegExp('KAKAOTALK', 'gi');
  const exec = regexp.exec(deviceUa);
  if (exec) {
    return true;
  }
  return false;  
}

export function isMobile(device) {
  if (device.getIn(['device', 'type']) === 'mobile') {
    return true;
  } else if (device.getIn(['device', 'model']) === 'iPad') {
    return true;
  }
  return false;
}

/**
 * version 명시 sample: 8.1.1
 */
export function isHigherKakaoTalkVersion(device, version) {
  const osName = device.getIn(['os', 'name']);
  const deviceUa = device.get('ua');
  const iosVersion = version;
  const aosVersion = version.replace(/\./g, '');

  let regexpPattern;
  if (osName === 'iOS') {
    regexpPattern = 'KAKAOTALK (\\d|\\.){5}';
  } else if (osName === 'Android') {
    regexpPattern = '(KAKAOTALK|KAKAOTALK_ONESTORE) \\d{7}';
  } else {
    return false;
  }

  try {
    const regexp = new RegExp(regexpPattern, 'gi');
    const exec = regexp.exec(deviceUa);
    if (exec) {
      const version = exec[0].slice(10);
      if (osName === 'iOS') {
        if (version >= iosVersion) {
          return true
        }
      } else if (osName === 'Android') {
        if (Number(version.slice(2, 6)) >=  Number(aosVersion)) {
          return true
        }
      }

    }
  } catch (e) {
    console.error('KAKAOTALK version check failed', e);
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/deviceUtil.js